module.exports = __webpack_public_path__ + "img/plus_d2.7588ed22.png";